import { helper } from './glyphs/icons'

export const IconName = helper

export const IconSize = {
  Small: 'sm',
  Medium: 'md',
  Large: 'lg',
} as const
